import type { DummyFoods } from './dummyFoods'

export const turkey: DummyFoods = {
  Turkey: {
    Breast: {
      'With skin': {
        Cooked: ['Turkey breast with skin (cooked)'],
        Raw: ['Turkey breast with skin (raw)'],
      },
      'Without skin': {
        Cooked: ['Turkey breast without skin (cooked)'],
        Raw: ['Turkey breast without skin (raw)'],
      },
    },
    Leg: {
      'With skin': {
        Cooked: ['Turkey leg with skin (cooked)'],
        Raw: ['Turkey leg with skin (raw)'],
      },
      'Without skin': {
        Cooked: ['Turkey leg without skin (cooked)'],
        Raw: ['Turkey leg without skin (raw)'],
      },
    },
    Wing: {
      'With skin': {
        Cooked: ['Turkey wing with skin (cooked)'],
        Raw: ['Turkey wing with skin (raw)'],
      },
      'Without skin': {
        Cooked: ['Turkey wing without skin (cooked)'],
        Raw: ['Turkey wing without skin (raw)'],
      },
    },
  },
}
